import {
  OnboardingUserFormValues,
  RoleFormValues,
} from '../../../types';

export type RoleTypeOption = {
  _id: string;
  name?: {he?: string; en?: string};
};

export function isManagerRoleType(en: string | undefined): boolean {
  const lower = (en ?? '').toLowerCase().trim();
  return lower.endsWith('manager') || lower.endsWith('management');
}

export function getManagerRoleIds(
  nodeRoles: RoleFormValues[],
  allRoleTypes?: {data?: RoleTypeOption[]},
): Set<string> {
  const managerRoleTypeIds = new Set(
    (allRoleTypes?.data ?? [])
      .filter(rt => isManagerRoleType(rt.name?.en))
      .map(rt => rt._id),
  );

  return new Set(
    nodeRoles
      .filter(
        role =>
          managerRoleTypeIds.has(role.roleType) ||
          isManagerRoleType(role.roleType),
      )
      .map(role => role.id),
  );
}

export function getUserDisplayName(user: OnboardingUserFormValues): string {
  return (
    `${user.firstName} ${user.lastName}`.trim() || user.email || user.id
  );
}

export function isEligibleRegulationAssignee(
  user: OnboardingUserFormValues,
  managerRoleIds: Set<string>,
  selectedDepartment?: string,
): boolean {
  if (!managerRoleIds.has(user.roleId)) return false;
  if (!selectedDepartment) return true;
  if (user.departmentId.includes('all')) return true;
  return (
    Array.isArray(user.departmentId) &&
    user.departmentId.includes(selectedDepartment)
  );
}

export function getEligibleRegulationAssigneeUsers(
  nodeUsers: OnboardingUserFormValues[],
  nodeRoles: RoleFormValues[],
  allRoleTypes: {data?: RoleTypeOption[]} | undefined,
  selectedDepartment?: string,
): OnboardingUserFormValues[] {
  const managerRoleIds = getManagerRoleIds(nodeRoles, allRoleTypes);
  return nodeUsers.filter(user =>
    isEligibleRegulationAssignee(user, managerRoleIds, selectedDepartment),
  );
}

export function matchRegulationAssigneeNameToId(
  name: string,
  eligibleUsers: OnboardingUserFormValues[],
): {assignee: string} | {error: string} {
  const trimmed = name.trim();
  if (!trimmed) return {assignee: ''};

  const normalized = trimmed.toLowerCase();
  const user = eligibleUsers.find(u => {
    const displayName = getUserDisplayName(u).toLowerCase();
    return (
      displayName === normalized ||
      u.email.toLowerCase().trim() === normalized
    );
  });

  if (!user) {
    return {error: `שיוך אישי לא תקין: ${trimmed}`};
  }

  return {assignee: user.id};
}
